export default __webpack_public_path__ + "static/media/icon_search_tag_post.21ee6612.svg";